import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Backstop for the GA internal-page guard in public/index.html. The inline
// script there owns the internal-prefix list and already flips the
// ga-disable kill switch synchronously inside history.pushState/replaceState;
// this re-syncs it for any route change that reaches React some other way.

export default function AnalyticsRouteGuard() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof window.__syncGaDisable === 'function') {
      window.__syncGaDisable(pathname);
    }
  }, [pathname]);

  return null;
}
